module.exports = new __parcel__URL__("line-chart-unmapped.3a47f8c5.svg").toString();